import { z } from 'zod';

import { CompanyId, CustomCompanyFieldId, UserId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';

export const CUSTOM_COMPANY_FIELD_KEY_REGEX = /^[a-zA-Z][a-zA-Z0-9_]*$/;

export const CustomCompanyField = z.object({
  id: CustomCompanyFieldId,
  companyId: CompanyId,
  key: z.string().min(1).max(64).regex(CUSTOM_COMPANY_FIELD_KEY_REGEX),
  label: z.string().min(1).max(120),
  value: z.string().max(2000),
  createdById: UserId,
  updatedById: UserId,
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});
export type CustomCompanyField = z.infer<typeof CustomCompanyField>;

export const CreateCustomCompanyFieldInput = CustomCompanyField.pick({
  key: true,
  label: true,
  value: true,
});
export type CreateCustomCompanyFieldInput = z.infer<typeof CreateCustomCompanyFieldInput>;
